import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm13.003 7.49-2.129-4.215c-.777-1.538-2.972-1.538-3.749 0l-2.13 4.214-4.665.723c-1.702.264-2.38 2.351-1.159 3.565l3.35 3.328-.754 4.661c-.275 1.7 1.5 2.99 3.033 2.203l4.2-2.158 4.2 2.158c1.532.788 3.308-.503 3.032-2.203l-.754-4.661 3.35-3.328c1.222-1.214.544-3.301-1.158-3.565l-4.667-.723Zm-6.662 1.772a.1.1 0 0 1-.074.054l-5.631.872a.1.1 0 0 0-.055.17l4.043 4.016a.1.1 0 0 1 .028.087l-.91 5.625a.1.1 0 0 0 .144.105l5.068-2.605a.1.1 0 0 1 .091 0l5.069 2.605a.1.1 0 0 0 .144-.105l-.91-5.625a.1.1 0 0 1 .028-.087l4.043-4.016a.1.1 0 0 0-.055-.17l-5.631-.872a.1.1 0 0 1-.075-.054l-2.57-5.085a.1.1 0 0 0-.178 0l-2.57 5.085Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19 20c1.616 0 3.048.117 4.333.329l-.967 1.878A25.647 25.647 0 0 0 19 22c-4.76 0-8.198 1.44-10.983 3.32C6.751 26.172 6 27.754 6 29.563V34h13.027l-.235 1.446c-.03.188-.047.372-.053.554H4v-6.436c0-2.326.97-4.601 2.898-5.903C9.961 21.594 13.782 20 19 20Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const PictogramServicesPerson40 = createIcon(IconComponent);